import React from 'react';
import Header from '../Header';
import { Box } from '@mui/material';
import BuildingsTable from '../tables/BuildingsTable';
import DynamicBreadcrumbs from '../breadcrumbs/DynamicBreadcrumbs';
import Typography from '@mui/material/Typography';
import pageStyles from './pageStyles';

function MainPage() {
  return (
    <>
      <Header />
      {
        <Box sx={{ margin: 'auto', width: '80%' }}>
          <Box sx={pageStyles.dynamicBreadcrumbs}>
            <DynamicBreadcrumbs />
          </Box>
          <Typography sx={pageStyles.label} component="h1" variant="h4" align="center">
            Network Control Center
          </Typography>
          <BuildingsTable />
        </Box>
      }
    </>
  );
}

export default MainPage;
